module.exports = __webpack_public_path__ + "assets/images/green-xmas-scrollyimage2-desktop.jpg?v=705c995d";